"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M22 2H2v20l4-4h16zm-9 9h-2V5h2zm0 4h-2v-2h2z"
}), 'AnnouncementSharp');